import styled from "styled-components";

export const StyledBottomNav = styled.nav`
  display: flex;
  padding: 20px 10%;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.card};
  box-shadow: 15px 4px 22px 0px rgba(95, 126, 251, 0.2);
  transform: translateZ(0);
  will-change: transform;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  height: 40px;
  img {
    height: 28px;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 28px 30%;
    display: none;
  }
`;
